// Module
var code = `<custom-fee-list form="\$ctrl.form"
                 fee-definitions="\$ctrl.feeDefinitions"
                 product-group="'ACCOUNT'"
                 on-change="\$ctrl.onSave()">
</custom-fee-list>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/deposit-account/fees/deposit-account-fees.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;